import "./styles.scss";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import DetailsCard from "components/DetailsCard";
import Widget from "../../Widget";

import { useNewWebsite } from "context/client/new_website";

import useResponsive from "libs/helpers/useResponsive";

const mainClass = "new-website-content__check-your-data";

const CheckYourData = () => {
  const { t } = useTranslation();
  const { min } = useResponsive();

  const { prevStep, submitForm } = useNewWebsite();

  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    try {
      setLoading(true);
      await submitForm();
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  return (
    <div className={mainClass}>
      <DetailsCard
        {...(min.lg ? { title: t("Back"), backAction: () => prevStep() } : {})}
        resetOnMobile
      >
        <div className={`${mainClass}__wrapper`}>
          <Widget
            isPayment
            isLoading={loading}
            onClick={() => {
              onSubmit();
              window.gtag("event", "payment", {
                click_text: t("Payment"),
              });
            }}
          />
        </div>
      </DetailsCard>
    </div>
  );
};

export default CheckYourData;
